//Library Imports
import { Popover } from "antd";
import { useLayoutEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
//Local Imports
import AddMore from "./AddMore";
import PopoverContent from "./PopoverContent";
import InfoPopover from "modules/Common/Components/InfoPopover";
import ExclamationDiamond from "assets/img/icons/ExclamationDiamond.svg";
import { ReactComponent as ConnectionIcon } from "assets/img/icons/connectionBlack.svg";
import ConditionIcon from "../../../assets/img/icons/conditionIcon.svg";
import { WFStatus, WFStatusEnum, ControlNameEnum, ConditionEnum } from "../interfaces";
import { RootState } from "store";
//Style Imports
import styled from "styled-components";

type Props = {
  conditionLabel: string;
  conditionRefrence: string;
  childrenLeft: object;
  childrenRight: object;
  disabled: boolean;
  id: string;
  data: object;
  children: string[];
  scaling: string;
};
const ConditionNode = (props: Props) => {
  const { conditionLabel, conditionRefrence, childrenLeft, childrenRight, disabled, id, data, children, scaling } =
    props;

  const [width, setWidth] = useState(0);
  const [widthLeft, setWidthLeft] = useState(0);
  const [widthRight, setWidthRight] = useState(0);

  const ref = useRef(null);
  const leftRef = useRef(null);
  const rightRef = useRef(null);
  const IfElseConditions: any[] = useSelector(
    (state: RootState) => state.automation.workflow.flow[id].detail.conditions
  );
  const conditionOperators = useSelector(
    (state: RootState) => state.automation.workflow.flow[id].detail.conditionOperators
  );

  // Redux state
  const workflowStatus: WFStatus = useSelector((state: RootState) => state.automation.workflow?.detail?.status);
  const errorNodes: string[] = useSelector((state: RootState) => state.automation.workflow?.detail?.errorNodes);

  const isStatusActive = workflowStatus === WFStatusEnum.ACTIVE;
  const isAnyLink = conditionRefrence.includes("Any Link");

  // the following code will use in future
  // const [{ transform }, dragRef] = useDrag(
  //   () => ({
  //     type: ItemTypes.CARD,
  //     item: { controlName: conditionLabel, nodeTitle: conditionRefrence, ...data, nodeId: id },
  //   }),
  //   []
  // );

  useLayoutEffect(() => {
    setWidth(ref.current.offsetWidth);
    setWidthLeft(leftRef.current.offsetWidth);
    setWidthRight(rightRef.current.offsetWidth);
  }); // remove [] because it only run on the first render but we have to recalculate it after a new node is created in the workflow

  let isEmailLinkError = errorNodes.includes(id);
  let isNodeError = isEmailLinkError || data?.error;

  let nodeErrorText =
    conditionLabel === ConditionEnum.HAS_CLICKED && errorNodes.includes(id)
      ? "The link has been removed from the email"
      : "The link was removed from the email";

  const defaultTypes: any = {
    articles: "Button",
    buttons: "Button",
    img_videos: "Image/Video",
  };
  return (
    <Wrapper>
      <div className="uperline"></div>
      <div className="d-block">
        {isNodeError && <InfoPopover infoText={nodeErrorText} width={188} errorNode={true} />}
        <Popover
          placement="topRight"
          content={!isStatusActive ? <PopoverContent id={id} isCondition canCopy={false} controlName={ControlNameEnum.IF_ELSE} /> : null}
          getPopupContainer={() => document.querySelectorAll(".workflow-container")[0] as HTMLElement}
          // trigger="click"
          overlayClassName="workflow-popover workflow-popover-right"
        >
          <div
            className={`contition-wrapper ${disabled ? "disabled" : ""} ${isNodeError && "error-wrapper"} ${scaling === "scaled" ? "zoom-out" : "zoom-in"
              }`}
          // style={{ transform }}
          // ref={dragRef}
          >
            {/* disabled toggle class for disable on drag */}
            <div style={{ display: "flex", justifyContent: "center", lineHeight: "1", alignItems: "flex-start" }}>
              <img className="caution-icon-in-popup" src={ConditionIcon} alt="" />
              <div>
                <div className="contition-label">Does the contact match the following conditions?</div>
                <span className="conditions-span">
                  {IfElseConditions?.map((condition: any, index: any) => (
                    <>
                      {index !== 0 ? (
                        <div style={{ textAlign: "center" }}>
                          <span className="operatorStyles">{conditionOperators[index - 1]}</span>
                        </div>
                      ) : null}
                      <span className="text-wrapper-span">
                        <span className="contition-type">
                          {condition?.controlName?.charAt(0).toUpperCase() + condition?.controlName?.slice(1)}
                          {<>:</>}
                        </span>{" "}
                        {condition?.emailName ? (
                          <span className="email-name-pill">
                            <label className="email-name-text" title={condition?.emailName}>
                              {condition?.emailName}
                            </label>
                          </span>
                        ) : (
                          <span style={{ paddingRight: "8px" }}></span> // Space in between
                        )}
                        {condition.hasOwnProperty("link") && condition?.controlName === ConditionEnum.HAS_CLICKED && (
                          <span style={{ marginRight: "3px" }}>
                            <ConnectionIcon />
                          </span>
                        )}
                        {isEmailLinkError ? (
                          <span className="condition-label condition-label-error">{nodeErrorText}</span>
                        ) : // data?.link === 'Any Link' ? (
                          condition?.controlName === ConditionEnum.HAS_CLICKED ? (
                            condition?.link?.includes("Any Link") ? (
                              <span className="link-label any-link-label">{condition?.link}</span>
                            ) : (
                              <a
                                href={condition?.link}
                                target="_blank"
                                rel="noreferrer"
                                className="link-label lineHeight"
                              >
                                {condition?.link}
                              </a>
                            )
                          ) : (
                            ""
                          )}
                      </span>
                      <br />
                    </>
                  ))}
                </span>
              </div>
            </div>
          </div>
        </Popover>
      </div>
      <div className="double-downline" ref={ref}>
        <div className="left-condition" ref={leftRef}>
          <div className="contition-downline-left">
            <div
              className="left-arm"
              style={{
                right: `${Number(width) / Number(2)}px`,
                width: `${Number(width) / Number(2) - Number(widthLeft) / Number(2)}px`,
              }}
            >
              <svg width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="none" fill="#5f667e">
                <path
                  d="M 0,100 C 0,0 100,100 100,0"
                  fill="none"
                  stroke="#979797"
                  strokeWidth="2"
                  vectorEffect="non-scaling-stroke"
                ></path>
              </svg>
            </div>
            <span className="condition-true">Yes</span>
            <div className="add-more-row">
              <AddMore
                id={id}
                disabled={disabled}
                side="left"
                hasChildren={!!children?.[0] && children?.[0] !== ""}
              />
            </div>
          </div>
          <div className="arm-container">{childrenLeft}</div>
        </div>
        <div className="right-condition" ref={rightRef}>
          <div className="contition-downline-right">
            <div
              className="right-arm"
              style={{
                left: `${Number(width) / Number(2)}px`,
                width: `${Number(width) / Number(2) - Number(widthRight) / Number(2)}px`,
              }}
            >
              <svg width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="none" fill="#5f667e">
                <path
                  d="M 100,100 C 100,0 0,100 0,0"
                  fill="none"
                  stroke="#979797"
                  strokeWidth="2"
                  vectorEffect="non-scaling-stroke"
                ></path>
              </svg>
            </div>
            <span className="condition-false">No</span>
            <div className="add-more-row">
              <AddMore id={id} disabled={disabled} side="right" hasChildren={!!children?.[1]} />
            </div>
          </div>
          <div className="arm-container">{childrenRight}</div>
        </div>
      </div>
    </Wrapper>
  );
};

export default ConditionNode;

const Wrapper = styled.div`
  display: table;
  text-align: center;
  margin: 0 auto;
  .link-pill {
    background: #8aa4e5;
    border-radius: 16px;
    padding: 1px 6px 2px 6px;
    margin-left: 8px;
  }
  .link-pill-content {
    color: white;
    font-size: 12px;
    font-weight: 500;
    font-family: "Roboto", sans-serif;
    white-space: nowrap;
    letter-spacing: -0.4px;
    text-decoration-line: underline;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 11px;
    }
  }
  .email-name-pill {
    padding: 1px 5px;
    background: #e6f5ea;
    border: 1px solid #1ec252;
    border-radius: 6px;
    margin-right: 5px;
    display: inline-block;
  }
  .email-name-text {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: -0.4px;
    color: #7e7e7e;
    max-width: 120px;
    overflow: hidden;
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: middle;
  }
  .d-block {
    position: relative;
    & > img {
      margin: 0;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      margin-left: -32px;
    }
  }
  .contition-wrapper {
    background-color: #f5f5f5;
    border-radius: 8px;
    padding: 14px 20px;
    border: 1px solid #929292;
    display: inline-block;
    margin: 0 auto;
    text-align: left;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    position: relative;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      border-radius: 6px;
      padding: 8px 12px;
    }
    &.disabled {
      opacity: 0.3;
      pointer-events: none;
    }
    &.zoom-out {
      border: 2px solid #7e7e7e;
    }
    &:hover .drag-handle {
      opacity: 1;
    }
    .contition-label {
      color: #7e7e7e;
      font-size: 14px;
      font-weight: 500;
      font-family: "Roboto", sans-serif;
      white-space: nowrap;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 12px;
      }
    }
    .text-wrapper-span {
      display: inline-block;
      max-width: 500px;
      white-space: normal;
      text-align: left;
      /* float: left; */
      overflow: hidden;
      margin: 9px 0;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        max-width: 450px;
      }
    }
    .link-label {
      color: #8aa4e5;
      text-decoration: underline;
      text-decoration-color: #8aa4e5;
      font-size: 14px;
      font-weight: 500;
      font-family: "Roboto", sans-serif;
      /* white-space: nowrap; */
      /* display: inline-flex;
      max-width: 450px;
      overflow: hidden;
      white-space: normal; */
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 12px;
      }
    }
    .any-link-label {
      text-decoration: none;
      color: #8aa4e5 !important;
    }
    .condition-label-error {
      color: #e41010;
    }
    .drag-handle {
      position: absolute;
      right: -36px;
      top: 50%;
      transform: translateY(-50%);
      cursor: grab;
      transition: 0.5s;
      opacity: 0;
      img {
        width: 16px;
        height: 16px;
      }
    }
    span:not(.link-pill-content) {
      color: #7e7e7e;
      font-size: 14px;
      font-family: "Roboto", sans-serif;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 12px;
      }
      &.contition-type {
        font-weight: 700;
        /* margin-right: 5px; */
        color: #000000;
      }
      &.contition-label {
        font-weight: 500;
      }

      &.link-pill {
        color: white;
      }
    }
  }
  .lineHeight {
    line-height: 15px;
  }
  .error-wrapper {
    border-color: #e41010;
    background-color: #ffe7e7;
  }
  .caution-icon-in-popup {
    margin-right: 8px;
    margin-bottom: 10px;
  }
  .double-downline {
    display: inline-flex;
    position: relative;
    padding-top: 70px;
    .left-condition,
    .right-condition {
      min-width: 470px;
      .contition-downline-left,
      .contition-downline-right {
        width: 50%;
        .left-arm,
        .right-arm {
          height: 70px;
          position: absolute;
          top: 0;
          &:after {
            content: "";
            width: 8px;
            height: 8px;
            border-radius: 10px;
            background-color: #979797;
            display: inline-block;
            position: absolute;
            bottom: -3px;
          }
        }
        .condition-false,
        .condition-true {
          font-size: 16px;
          font-weight: 700;
          font-family: "Roboto", sans-serif;
          &:after {
            content: "";
            width: 2px;
            height: 20px;
            background-color: #979797;
            display: inline-block;
          }
        }
        .add-more-row {
          clear: both;
        }
      }
    }
    .left-condition {
      .contition-downline-left {
        float: right;
        .left-arm {
          &:after {
            left: -3px;
          }
        }
        .condition-true {
          color: #27ce0a;
          float: left;
          margin-left: -14px;
          &:after {
            float: left;
            margin: 24px -14px 0px 13px;
          }
        }
        .add-more-row {
          text-align: left;
          margin-left: -14px;
        }
      }
    }
    .right-condition {
      .contition-downline-right {
        float: left;
        .right-arm {
          &:after {
            right: -3px;
          }
        }
        .condition-false {
          color: #e41010;
          float: right;
          margin-right: -13px;
          &:after {
            margin: 24px 13px 0px -13px;
            float: right;
          }
        }
        .add-more-row {
          text-align: right;
          margin-right: -12px;
        }
      }
    }
  }
  .uperline {
    background-color: #979797;
    width: 2px;
    height: 30px;
    margin: 0 auto;
    position: relative;
    z-index: 1;
    clear: both;
    &:after {
      content: "";
      width: 8px;
      height: 8px;
      border-radius: 10px;
      background-color: #979797;
      display: inline-block;
      position: absolute;
      bottom: -3px;
      left: -3px;
    }
  }
  .operatorStyles {
    background: #ffffff;
    border: 1px solid #1ec252;
    border-radius: 6px;
    padding: 1px 5px;
    margin-right: 5px;
    gap: 10px;

    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: #000000 !important;
  }
  .nodeDisabled{
    opacity: 0.5;
    pointer-events: none;
  }
`;
